import React, { useState, useCallback, memo } from 'react';
import {
  arrayOf, object, shape, string, number,
} from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import InstallmentsItem from './InstallmentsItem';
import './Installments.scss';
import { handleKeyboardEvent } from '../../../shared/utils/commonUtils';

const MoreInstallments = ({ installmentList }) => {
  if (installmentList.length === 0) {
    return null;
  }

  const [ seeMore, setSeeMore ] = useState(false);
  const toggleChange = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
    setSeeMore(!seeMore);
  }, [ seeMore, setSeeMore ]);

  return <React.Fragment>
    { seeMore
      && installmentList.map((installment, index) => <InstallmentsItem
        key={index}
        {...installment}/>)
    }
    <div
      role="button"
      tabIndex="0"
      className="installments-list__seeMoreLess"
      onKeyDown={handleKeyboardEvent(toggleChange, 'Enter')}
      onClick={toggleChange}>
      {
        seeMore ? <Locale id="checkout.lib.components.text.seeLess" />
          : <Locale id="checkout.lib.components.text.seeMore" />
      }
    </div>
  </React.Fragment>;
};

MoreInstallments.propTypes = {
  installmentList: arrayOf(shape({
    remainingBalance: number,
    currencyCode: string,
    dueDate: object,
  })),
};

MoreInstallments.defaultProps = {
  installmentList: [],
};

export default memo(MoreInstallments);
